import { post } from '@core/api/baseApi';
import { PostOrganizationLogoResponse } from '@core/types/ApiResponses';

const setOrganizationLogo = (formData: FormData): Promise<PostOrganizationLogoResponse> => post(`/organizations/custom-logo`, formData);

export default setOrganizationLogo;
